import { Alert, Skeleton } from "antd"
import { useGetJobUrlQuery } from "../domain/jobs/jobsQueries"
import { useEffect } from "react"

const JobRedirectPage = () => {
  const jobId = window.location.hash.replace('#!/job-redirect/', '')
  const jobUrlQuery = useGetJobUrlQuery(parseInt(jobId))

  useEffect(() => {
    if (jobUrlQuery.data) {
      window.location.href = `/#!/${jobUrlQuery.data}`
    }
  }, [jobUrlQuery.data])

  if (jobUrlQuery.isLoading || jobUrlQuery.data) {
    return <div id="main" className="main-dashboard fluid-container">
      <Skeleton active />
    </div>
  }

  return <div id="main" className="main-dashboard fluid-container">
    <section>
      <Alert message="Job not found" type="error" />
    </section>
  </div>
}

export default JobRedirectPage